import React from 'react';
import { Link } from 'react-router';

import styles from './ProjectCard.module.css';

export const ProjectCard = ({ project }: { project: any }) => {
  return (
    <div className={styles.card}>
      <Link
        to={`/portfolio/${project.id}`}
        state={{ navName: project.name }}
        className={styles.cardContent}
      >
        <div className={styles.imageBox}>
          <img
            className={styles.cardImage}
            src={project.heroImage}
            alt={project.name}
          />
        </div>
        <div className={styles.info}>
          <h2 className={styles.title}>{project.name}</h2>
          <p className={styles.subtitle}>
            {`${project.year} ${project.location} ${project.area}m`}
            <sup>2</sup>
          </p>
        </div>
      </Link>
    </div>
  );
};
